import React from 'react';
import { ArrowRightIcon, CalendarCheckIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { NewsletterEmbed } from '../components/NewsletterEmbed';
export function BookedPage() {
  return <div className="min-h-screen flex flex-col w-full bg-white font-body" data-id="element-484" data-mp="10qazryrlyd5j">
      <Navigation data-id="element-485" data-mp="10pj7awtb4vjh" />
      <main className="flex-grow flex flex-col" data-id="element-486" data-mp="401p5id51h0w">
        <section className="w-full pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-487" data-mp="41d4mffy4d7u">
          <div className="max-w-4xl mx-auto" data-id="element-488" data-mp="90677ctp2jt8">
            <CalendarCheckIcon className="w-10 h-10 text-brand-orange mb-6" aria-hidden="true" data-id="element-489" data-mp="91901qakuwbs" />
            <h1 className="text-4xl md:text-5xl font-bold text-brand-navy leading-tight mb-6" data-id="element-490" data-mp="i0cj4u9qvbqa">
              You're booked.
            </h1>
            <p className="text-xl md:text-2xl text-brand-gray leading-relaxed max-w-2xl" data-id="element-491" data-mp="1ofdizb1w4e25">
              Your call is scheduled. A calendar invite is on its way to your
              inbox with the time and the Zoom link. Looking forward to talking.
            </p>
          </div>
        </section>

        <section aria-labelledby="booked-newsletter-heading" className="w-full flex-grow bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-492" data-mp="u6f5l1plwuwk">
          <div className="max-w-4xl mx-auto" data-id="element-493" data-mp="k6o94uhhk5tu">
            <h2 id="booked-newsletter-heading" className="text-xl md:text-2xl font-bold text-brand-navy mb-3" data-id="element-494" data-mp="ka28ruyrm0xl">
              While you wait
            </h2>
            <p className="text-base md:text-lg text-brand-gray leading-relaxed mb-6 max-w-2xl" data-id="element-495" data-mp="bdjjqttnmx6a">
              Get Broken Pencils, my newsletter on AI transformation and
              leadership, every other week.
            </p>
            <div className="w-full max-w-[480px] mb-6" data-id="element-496" data-mp="3so154xpnfobm">
              <NewsletterEmbed data-id="element-497" data-mp="3splzam81x58y" />
            </div>
            <a href="https://newsletter.breakapencil.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center font-bold text-brand-orange hover:text-brand-orange-hover transition-colors" data-id="element-498" data-mp="3olnz086zpoeb">
              Read past issues
              <ArrowRightIcon className="w-5 h-5 ml-2" aria-hidden="true" data-id="element-499" data-mp="3515uhgn68n98" />
            </a>
          </div>
        </section>
      </main>
      <Footer data-id="element-500" data-mp="3a1bj0ny59tn3" />
    </div>;
}